import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs } from "@fortawesome/free-solid-svg-icons";

import Geral from "./Geral";
import CobrancaConfig from "./Cobranca";

import "./styles.css";
import { useUserInfor } from "../../../../../../Context/User";
import InternalError from "../../../../../../Pages/Errors/InternalError";
import AssistenciaConfig from "./AssistenciaConfig";
import VistoriaEntregaChavesConfig from "./VistoriaEntregaChaves";
import AtendimentoWhatsappConfig from "./AtendimentoWhatsappConfig";
import AtendimentoClienteConfig from "./AtendimentoClienteConfig";
import RepasseConfig from "./Repasse";
import useAsyncEffect from "../../../../../../hooks/useAsyncEffect";
import {
    AtualizarConfigModuloController,
    ListConfigModuloController,
} from "../../../../../../Controllers/Geral/ConfigGeral/ConfigGeralController";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import VendasConfig from "./Vendas/Vendas";
import { useState } from "react";
import AutomacaoConfig from "./AutomacaoConfig";

export default function ConfiguracaoGeral() {
    const { Config } = useUserInfor();
    const [activeTab, setActiveTab] = useState<string | null>(null);

    const handleTabClick = (tabId: string) => {
        setActiveTab(tabId);
    };

    const { execute: AtualizarConfigModulo } = useAsyncCallback(
        AtualizarConfigModuloController
    );

    const {
        value: lstConfigModulo,
        execute: ListConfigModulo,
        loading: lstConfigModuloLoading,
    } = useAsyncEffect(() => ListConfigModuloController());

    return Config.ConfigVersaoWebServiceDTO ? (
        <div className="configGeral">
            <div className="row p-5">
                <h1 className="col-12">
                    <FontAwesomeIcon className="mr-2" icon={faCogs} />{" "}
                    Configurações Gerais
                </h1>
                <div className="col-12 col-md-3 mb-2">
                    <ul
                        className="nav nav-dark dark-text-nav flex-column nav-pills"
                        role="tablist"
                    >
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link active"
                                id="geral-tab"
                                data-toggle="tab"
                                href="#geral"
                                role="tab"
                                aria-controls="geral"
                                aria-selected="true"
                            >
                                Geral
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link"
                                id="cobranca-tab"
                                data-toggle="tab"
                                href="#cobranca"
                                role="tab"
                                aria-controls="cobranca"
                                aria-selected="false"
                            >
                                Cobrança
                            </a>
                        </li>

                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link"
                                id="assistencia-tab"
                                data-toggle="tab"
                                href="#assistencia"
                                role="tab"
                                aria-controls="assistencia"
                                aria-selected="false"
                            >
                                Assistência Técnica
                            </a>
                        </li>

                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link"
                                id="vendas-tab"
                                data-toggle="tab"
                                href="#vendas"
                                role="tab"
                                aria-controls="vendas"
                                onClick={() => handleTabClick("vendas")}
                            >
                                Vendas
                            </a>
                        </li>

                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link"
                                id="repasse-tab"
                                data-toggle="tab"
                                href="#repasse"
                                role="tab"
                                aria-controls="repasse"
                                aria-selected="false"
                            >
                                Repasse
                            </a>
                        </li>

                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link"
                                id="vistoriaEntregaChaves-tab"
                                data-toggle="tab"
                                href="#vistoriaEntregaChaves"
                                role="tab"
                                aria-controls="vistoriaEntregaChaves"
                                aria-selected="false"
                            >
                                Vistoria Entrega Chaves
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link"
                                id="atendimentoWhatsapp-tab"
                                data-toggle="tab"
                                href="#atendimentoWhatsapp"
                                role="tab"
                                aria-controls="atendimentoWhatsapp"
                                aria-selected="false"
                            >
                                Atendimento Whatsapp
                            </a>
                        </li>
                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link"
                                id="atendimentoCliente-tab"
                                data-toggle="tab"
                                href="#atendimentoCliente"
                                role="tab"
                                aria-controls="atendimentoCliente"
                                aria-selected="false"
                            >
                                Atendimento ao Cliente
                            </a>
                        </li>

                        <li className="nav-item" role="presentation">
                            <a
                                className="nav-link"
                                id="automacao-tab"
                                data-toggle="tab"
                                href="#automacao"
                                role="tab"
                                aria-controls="automacao"
                                aria-selected="false"
                            >
                                Automação
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="col-12 col-md-9">
                    <div className="tab-content" id="myTabContent">
                        <div
                            className="tab-pane fade show active"
                            id="geral"
                            role="tabpanel"
                            aria-labelledby="geral-tab"
                        >
                            <Geral />
                        </div>
                        <div
                            className="tab-pane fade"
                            id="cobranca"
                            role="tabpanel"
                            aria-labelledby="cobranca-tab"
                        >
                            <CobrancaConfig
                                lstConfigModulo={lstConfigModulo}
                                AtualizarConfigModulo={AtualizarConfigModulo}
                                ListConfigModulo={ListConfigModulo}
                            />
                        </div>
                        <div
                            className="tab-pane fade"
                            id="assistencia"
                            role="tabpanel"
                            aria-labelledby="assistencia-tab"
                        >
                            <AssistenciaConfig
                                lstConfigModulo={lstConfigModulo}
                                AtualizarConfigModulo={AtualizarConfigModulo}
                                ListConfigModulo={ListConfigModulo}
                            />
                        </div>

                        <div
                            className="tab-pane fade"
                            id="vendas"
                            role="tabpanel"
                            aria-labelledby="vendas-tab"
                        >
                            {activeTab === "vendas" && (
                                <>
                                    <VendasConfig />
                                </>
                            )}
                        </div>
                        <div
                            className="tab-pane fade"
                            id="repasse"
                            role="tabpanel"
                            aria-labelledby="repasse-tab"
                        >
                            <RepasseConfig
                                lstConfigModulo={lstConfigModulo}
                                AtualizarConfigModulo={AtualizarConfigModulo}
                                ListConfigModulo={ListConfigModulo}
                            />
                        </div>

                        <div
                            className="tab-pane fade"
                            id="vistoriaEntregaChaves"
                            role="tabpanel"
                            aria-labelledby="vistoriaEntregaChaves-tab"
                        >
                            <VistoriaEntregaChavesConfig
                                lstConfigModulo={lstConfigModulo}
                                AtualizarConfigModulo={AtualizarConfigModulo}
                                ListConfigModulo={ListConfigModulo}
                            />
                        </div>
                        <div
                            className="tab-pane fade"
                            id="atendimentoWhatsapp"
                            role="tabpanel"
                            aria-labelledby="atendimentoWhatsapp-tab"
                        >
                            <AtendimentoWhatsappConfig />
                        </div>
                        <div
                            className="tab-pane fade"
                            id="atendimentoCliente"
                            role="tabpanel"
                            aria-labelledby="atendimentoCliente-tab"
                        >
                            <AtendimentoClienteConfig
                                lstConfigModulo={lstConfigModulo}
                                AtualizarConfigModulo={AtualizarConfigModulo}
                                ListConfigModulo={ListConfigModulo}
                                lstConfigModuloLoading={lstConfigModuloLoading}
                            />
                        </div>
                        <div
                            className="tab-pane fade"
                            id="automacao"
                            role="tabpanel"
                            aria-labelledby="automacao-tab"
                        >
                            <AutomacaoConfig />
                        </div>
                    </div>
                </div>
            </div>
            <hr />
            <div className="w-100 text-right">
                <span className="mr-5">WebService: v16.00.63</span>
                <span>Banco de Dados: v12.8</span>
            </div>
        </div>
    ) : (
        <InternalError />
    );
}
